"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTabsOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            minHeight: undefined,
        },
        indicator: {
            backgroundColor: palette.text.primary,
        },
    });
};
//# sourceMappingURL=MuiTabs.js.map